<a routerLink="/">
  <img
    [src]="
      isCollapsed
        ? '/assets/images/icon.png'
        : '/assets/images/logos/logo-' + layout + '.svg'
    "
    alt="Univacity Logo"
    i18n-alt="@@logoAlt"
    class="logo"
/></a>
<un-nav [menus]="mainMenu" [noWrap]="true" class="nav h-sm h-md"></un-nav>
<div class="icons-wrapper">
  <div class="icons">
    <a (click)="openSearchDrawer()"
      ><un-icon class="h-sm" type="search" theme="outline"></un-icon
    ></a>

    @if (auth.isLoggedIn) {
    <nz-badge
      class="h-sm"
      [nzCount]="(messageFacade.unread$ | async) || 0"
      (click)="openMessagesPreview()"
    >
      <un-icon class="t-large h-sm" type="message" theme="fill"></un-icon>
    </nz-badge>
    }
    <un-user-nav class="h-sm"></un-user-nav>
    <a (click)="openSearchDrawer()"
      ><un-icon
        class="search-small h-md h-lg"
        type="search"
        theme="outline"
      ></un-icon
    ></a>
    <un-icon
      class="h-lg"
      type="menu"
      theme="outline"
      (click)="openMobileMenu()"
    ></un-icon>
  </div>
</div>
